export const cookieSessionName = 'sg-session-id';
export const userIdSessionIdCharSeparator = '#';
export const cookieSeparator = ';';
export const cookieNameSeparator = '=';

export const getCookieValue = (name: string): string | undefined => {
    return document?.cookie
        ?.split(cookieSeparator)
        ?.find(row => row.startsWith(`${name}${cookieNameSeparator}`))
        ?.split(cookieNameSeparator)[1];
};

export const setCookieValue = (name: string, value: string) => {
    document.cookie = `${name}${cookieNameSeparator}${value}`;
};

export const getSessionIdStored = (userId: string): string | undefined => {
    const cookieSessionIdUserPosition = 0;
    const cookieSessionIdPosition = 1;

    const cookieSession = getCookieValue(cookieSessionName);
    const hasSessionIdStored =
        cookieSession && cookieSession.split(userIdSessionIdCharSeparator)[cookieSessionIdUserPosition] === userId;
    if (hasSessionIdStored) {
        return cookieSession?.split(userIdSessionIdCharSeparator)[cookieSessionIdPosition];
    }
    return undefined;
};

export const storeSessionId = (userId: string, sessionId: string) => {
    setCookieValue(cookieSessionName, `${userId}${userIdSessionIdCharSeparator}${sessionId}`);
};
